import TeamLeadClubAdminDetails from './TeamLeadClubAdminDetails';

export default TeamLeadClubAdminDetails;
